/** Only explicitly listed, local versioned badge bitmaps can replace the SVG fallback. */
export function safeBadgeArtworkPath(value) {
  return typeof value === 'string' && /^\/images\/badges\/v[45]\/[a-z0-9_-]+\.(?:webp|png|jpe?g)$/.test(value) ? value : '';
}
export function badgeArtwork(manifest, key, tier) {
  if (![4, 5].includes(manifest?.version) || !Object.hasOwn(manifest?.badges || {}, key)) return '';
  return safeBadgeArtworkPath(manifest.badges[key]?.[tier > 0 ? 'color' : 'locked']);
}
